import React from 'react';
import {Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, Typography, useTheme} from '@material-ui/core';
import {DialogProps} from "@material-ui/core/Dialog/Dialog";

export interface ConfirmDialogProps {
    title?: string;
    open: boolean;
    onClose: () => void;
    onConfirm: () => void;
    dialogProps?: Omit<DialogProps, "open" | "onClose">;
    disabled?: boolean;
}

const ConfirmDialog: React.FC<ConfirmDialogProps> = ({title, open, onClose, dialogProps, children, disabled, onConfirm}) => {
    return (
        <Dialog
            fullWidth
            maxWidth="sm"
            open={open}
            onClose={onClose}
            {...dialogProps}
        >
            <Typography variant="h2" style={{padding: "8px 16px"}}>{title}</Typography>
            <DialogContent>
                <Box p={1}>
                    {children}
                </Box>
            </DialogContent>
            <DialogActions
                style={{
                    background: '#FFFCF5',
                    marginTop: 8,
                    padding: '4px 8px'
                }}
            >
                <Button size="large" onClick={onClose}
                        style={{fontWeight: 600, color: '#5f6368'}}>
                    Nej
                </Button>
                <Button
                    size="large"
                    type='submit'
                    aria-label="submit"
                    onClick={onConfirm}
                    color={"primary"}
                    style={{fontWeight: 600}}
                    disabled={disabled}
                >
                    Ja
                </Button>
            </DialogActions>
        </Dialog>
    )
}

export default ConfirmDialog;